export async function loadImage(url: string): Promise<HTMLImageElement | null> {
  try {
    return await load(url);
  } catch (error) {
    console.error(error);

    return null;
  }
}

function load(url: string): Promise<HTMLImageElement | never> {
  return new Promise((resolve, reject) => {
    const image = new Image();
    image.addEventListener("load", () => resolve(image), { once: true });
    image.addEventListener("error", (error) => reject(error), { once: true });
    image.src = url;
  });
}
